import { render, staticRenderFns } from "./allIntergral.vue?vue&type=template&id=7afcc764&scoped=true&"
import script from "./allIntergral.vue?vue&type=script&lang=js&"
export * from "./allIntergral.vue?vue&type=script&lang=js&"
import style0 from "./allIntergral.vue?vue&type=style&index=0&id=7afcc764&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afcc764",
  null
  
)

export default component.exports